import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import { onError/*, onSuccess*/ } from '../shared/messages';
import { GetGuests, GetCustomers, UpdateCustomers, UpdateGuest } from '../../api/services/crm';
import { GetReservation } from '../../api/services/pms';
import NationalitiesDropDown from '../shared/NationalitiesDropDown';
import Panel from '../shared/Panel';
import { useTextResources } from '../../language';
import { Form, Header, Confirm, Button} from 'semantic-ui-react';
import './style.css'
import { EntityType, HotelFeatureCodes} from '../shared/constants';
import { endpoint } from '../../api/http';
import CheckTaxExemptionPopup from '../CheckTaxExemptionPopup';
import { GetHotels } from '../../api/services/organization';

const FolioOwnerSummary = ({ OwnerId, OwnerTypeId, OnOwner, ReservationID , HotelID}) => {
    const text = useTextResources()
    const [owner, setOwner] = useState()
    const [origOwnerObject, setOrigOwnerObject] = useState()
    const [ownerType, setOwnerType] = useState()
    const [nationality, setNationality] = useState("")
    const [confirmNationality, setConfirmNationality] = useState(false)
    const [isUpdatingNationaity, setIsUpdatingNationaity] = useState(false)
    const [showCheckTaxExemptionPopup, setShowCheckTaxExemptionPopup] = useState(false)
    const [hasCheckTaxExemptionFeature, setHasCheckTaxExemptionFeature] = useState(false)
    const [hotel, setHotel] = useState(null)
    const [reservation, setReservation] = useState()

    useEffect(() => {
        if (OwnerId && OwnerTypeId) {
            (async () => {
                try {
                    switch (OwnerTypeId) {
                        case (EntityType.AGENT): {
                            const owner = await GetCustomers({
                                Id: OwnerId,
                                CustomerTypeId: [2],
                                IncludeGuest: true,
                                isMultipleSelect: false,
                            })
                            setOrigOwnerObject(owner && owner.Customer && owner.Customer[0])
                            setOwner(owner && owner.Customer && owner.Customer[0] && owner.Customer[0].Guest)
                            setNationality(owner && owner.Customer && owner.Customer[0] && owner.Customer[0].Guest && owner.Customer[0].Guest.NationalityID)
                            setOwnerType("AGENT")
                            break;
                        }
                        case (EntityType.COMPANY): {
                            const owner = await GetCustomers({
                                Id: OwnerId,
                                CustomerTypeId: [1],
                                IncludeGuest: true,
                                isMultipleSelect: false
                            })
                            setOrigOwnerObject(owner && owner.Customer && owner.Customer[0])
                            setOwner(owner && owner.Customer && owner.Customer[0] && owner.Customer[0].Guest)
                            setNationality(owner && owner.Customer && owner.Customer[0] && owner.Customer[0].Guest && owner.Customer[0].Guest.NationalityID)
                            setOwnerType("COMPANY")
                            break;
                        }
                        case (EntityType.ApartmentOwner): {
                            const owner = await GetGuests({
                                IDs: OwnerId,
                                IncludeImages: true,
                                IncludeGuestTitle: true,
                                IncludeNotes: true,
                                IncludeNationality: true,
                                IsApartmentOwner: true
                            })
                            setOrigOwnerObject(owner && owner[0])
                            setOwner(owner && owner[0]);
                            setNationality(owner && owner[0] && owner[0].NationalityID)
                            setOwnerType("Apartment Owner")
                            break;
                        }
                        case (EntityType.Guest): {
                            const owner = await GetGuests({
                                IDs: OwnerId,
                                IncludeImages: true,
                                IncludeGuestTitle: true,
                                IncludeNotes: true,
                                IncludeNationality: true
                            })
                            setOrigOwnerObject(owner && owner[0])
                            setOwner(owner && owner[0]);
                            setNationality(owner && owner[0] && owner[0].NationalityID)
                            setOwnerType("Guest")
                            break;
                        }
                        default:
                            break;
                    }
                } catch (error) {
                    onError(error)
                }
            })()
        }
    }, [OwnerId, OwnerTypeId])

    useEffect(() => {
        if (OnOwner) {
            OnOwner(owner)
        }
    }, [owner])

    useEffect(()=>{      
        if(ReservationID) {
            (async () => {
                const reservation = await GetReservation({
                    IDs: [ReservationID],
                    HotelID,
                    IncludeReservationCompanyAgent: true,
                    IncludeAddons: true,
                    IncludeAddonsWithChain: true,
                    IncludeRoom: true,
                    ExcludeBlockReservation: false,
                    IncludeProduct: true,
                    IncludeRoomType: true,
                    IncludeReservationDailyAccommodations: true,
                    IncludeCanceled: true
                })
                setReservation(reservation)

        })()
        }
    },[ReservationID])


    useEffect(()=>{      
        if(HotelID) {
            (async () => {
                const hotels = await GetHotels({ID: HotelID, IncludeHotelFeatures: true, IncludeLocation : true});
                const hotel = hotels[0];
                setHotel(hotel)
                setHasCheckTaxExemptionFeature(hotel.HotelFeatures.find(x => x.FeatureID === HotelFeatureCodes.CheckTaxExemption));
        })()
        }
    },[HotelID])

    const Item = ({ title, subtitle, ...props }) => {

        return <td {...props}>
            <Header size="tiny" {...props}>
                <Header.Subheader>{title}</Header.Subheader>
                <Header.Content>{subtitle}</Header.Content>
            </Header>
        </td>
    }

    Item.propTypes = {
        title: PropTypes.any,
        subtitle: PropTypes.any
    }

    const onNationalityChanged = (val) => {
        setNationality(val);
        setConfirmNationality(true)
    }

    const sendOwnerUpdate = async () => {
        setIsUpdatingNationaity(true)
        if (ownerType === "AGENT" || ownerType === "COMPANY") {
            origOwnerObject.Guest.NationalityID = nationality;
            const ownerData = await UpdateCustomers(origOwnerObject);
            setNationality(ownerData && ownerData.Guest.NationalityID)
        }
        else {
            origOwnerObject.NationalityID = nationality;
            const ownerData = await UpdateGuest(origOwnerObject);
            setNationality(ownerData && ownerData.NationalityID)
        }
        setIsUpdatingNationaity(false)
        setConfirmNationality(false)

        window.location.reload(false); //Full page refresh from browser's cache in order to see the correct and updated Total Price in the foliosCarousel CMP.
    }

    const ownerHref = () => {
        switch (OwnerTypeId) {
            case EntityType.AGENT:
                return ""
            case EntityType.Guest:
                if(window.isSelfie) {
                    return `${window.optima?.$optimaUrls?.Selfie || "" }GuestAccount#/guest360/${owner.Id}`
                } else {
                   return `${endpoint}CRM/GuestProfile/index/#/profile/${owner.Id}` 
                }
            default:
                return "";
        }
    }

    const onCheckTaxExemptionSave = (checkResult) => {
        if (checkResult.isSuccess) {
            setNationality(checkResult.updatedNationalityId)
        }
        setShowCheckTaxExemptionPopup(false)
    }
  
    return <div className="FolioOwnerSummary" >
        <Panel header={text("FolioOwner")} subheader={`${text("OwnerType")}: ${text(ownerType)}`} icon="address card outline" attached={true}>
            {owner && <table className="details">
                <tbody>
                    {(owner.FirstName || owner.LastName) && <tr><Item colSpan={2} title={text("Name")} subtitle={<a target="_blank" rel="noopener noreferrer" href={ownerHref()}>{owner.FirstName} {owner.LastName}</a>}></Item></tr>}
                    {owner.Phone && <tr><Item title={text("Phone")} subtitle={owner.Phone}></Item></tr>}
                    {owner.Email && <tr><Item title={text("Email")} subtitle={owner.Email}></Item></tr>}
                </tbody>
            </table>}
            <Form>
                <Form.Group unstackable widths={2}>
                    <Form.Field control={NationalitiesDropDown} label={text("Nationality")} textField="Name" descriptionField="Symbol" value={nationality} onChange={onNationalityChanged} />
                    <Form.Field>
                        {hasCheckTaxExemptionFeature && 
                        <Button size="tiny" className="form-button" primary onClick={() => setShowCheckTaxExemptionPopup(true)}>{text("CheckTaxExemption")}</Button>}
                    </Form.Field>
                </Form.Group>
            </Form>
        </Panel>
        {owner &&
            <Confirm
                dimmer="inverted"
                open={confirmNationality}
                header="Save updated Nationality"
                content={`Would you like to save the new nationality to: ${owner.FirstName + owner.LastName}?`}
                confirmButton={{ content: "Save", loading: isUpdatingNationaity, disabled: isUpdatingNationaity, positive: true }}
                cancelButton={{ content: "Cancel", negative: true, disabled: isUpdatingNationaity }}
                onCancel={() => setConfirmNationality(false)}
                onConfirm={() => sendOwnerUpdate()}
            />    
        }

        {owner &&
                <CheckTaxExemptionPopup 
                guest={owner}
                reservation={reservation}
                hotel={hotel}
                startOpen={showCheckTaxExemptionPopup}
                onClose={(res) => onCheckTaxExemptionSave(res)} />
        }
        </div>
}

FolioOwnerSummary.propTypes = {
    OwnerId: PropTypes.number,
    HotelID: PropTypes.number,
    OwnerTypeId: PropTypes.number,
    OnOwner: PropTypes.func,
    ReservationID: PropTypes.number,
}
export default FolioOwnerSummary